// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".el-date-editor[data-v-41b70be2], .el-input--small[data-v-41b70be2] {\n  width: 250px;\n}\n.ordinaryBill[data-v-41b70be2] {\n  background-color: #fff;\n  height: calc(100vh - 100px);\n  overflow: auto;\n}\n", ""]);
// Exports
module.exports = exports;
